import React from "react"
import MemberSearchContainer from "../../containers/MemberSearchContainer"

const MemberSearchPage = () => {
  return <MemberSearchContainer />
}
export default MemberSearchPage
